<template>
  <div class="HomeCollectionIntro">
    <div class="Layout">
      <div class="Layout-section" />
      <grid-item
        class="HomeCollectionIntro-content"
        sm="4"
        md="8"
        offset-md="2">
        <ai-typo
          class="HomeCollectionIntro-title"
          as="h2"
          variant="heading-02"
          color="white">
          {{ collectionIntroTitle }}
        </ai-typo>
        <ai-typo
          class="HomeCollectionIntro-description"
          as="p"
          variant="paragraph-03-regular"
          color="white">
          {{ collectionIntroDescription }}
        </ai-typo>
      </grid-item>
    </div>
  </div>
</template>

<script setup lang="ts">
interface HomeCollectionIntroProps {
  collectionIntroTitle: string;
  collectionIntroDescription: string;
}

defineProps<HomeCollectionIntroProps>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';

.HomeCollectionIntro {
  background: linear-gradient(
    105.41deg,
    colors.$stratos-900 10.8%,
    colors.$stratos-700 165.89%
  );
}
.HomeCollectionIntro-content {
  padding-top: constants.$padding-07;
  padding-bottom: constants.$padding-07;
}
.HomeCollectionIntro-title {
  text-align: center;
  margin-bottom: constants.$margin-01;
}
.HomeCollectionIntro-description {
  display: flex;
  text-align: center;
}
</style>
